import { Box, Chip, IconButton, Stack, Tooltip } from '@mui/material'
import { IDataTableColumn } from '../../../components/Tables/DataTable'
import { TCollaborator } from '../../../core/types/Collaborators'
import {
  IconDelete,
  IconDisable,
  IconEnable,
} from '../../../core/constants/IconConsts'

interface ISettingsCollaboratorsColumnsProps {
  onDelete: (value: TCollaborator) => void
  onUpdateStatus: (value: TCollaborator) => void
}

const statusColorMap: Record<
  string,
  { label: string; backgroundColor: string; color: string }
> = {
  false: {
    label: 'Desabilitado',
    backgroundColor: '#BD1C1C29',
    color: '#D4362C',
  },
  true: {
    label: 'Habilitado',
    backgroundColor: 'rgba(28, 189, 63, 0.16)',
    color: 'rgba(0, 157, 35, 1)',
  },
}

export const settingsCollaboratorsColumns = ({
  onDelete,
  onUpdateStatus,
}: ISettingsCollaboratorsColumnsProps): IDataTableColumn<TCollaborator>[] => [
  {
    id: 'name',
    label: 'Nome',
    minWidth: 170,
  },
  {
    id: 'email',
    label: 'Email',
    minWidth: 170,
  },
  {
    id: 'isEnabled',
    label: 'Status',
    minWidth: 170,
    render: (id, value) => {
      const { label, backgroundColor, color } =
        statusColorMap[value?.toString()] || statusColorMap['false']
      return <Chip label={label} size="small" sx={{ backgroundColor, color }} />
    },
  },
  {
    id: 'actions',
    label: 'Ações',
    width: 90,
    align: 'left',
    render: (id, value, row) => (
      <Stack direction="row">
        <Box sx={{ display: row.isEnabled ? 'block' : 'none' }}>
          <Tooltip title="Desabilitar Colaborador">
            <IconButton size="small" onClick={() => onUpdateStatus(row)}>
              <img src={IconDisable} alt="disable" />
            </IconButton>
          </Tooltip>
        </Box>
        <Box sx={{ display: row.isEnabled ? 'none' : 'block' }}>
          <Tooltip title="Habilitar Colaborador">
            <IconButton size="small" onClick={() => onUpdateStatus(row)}>
              <img src={IconEnable} alt="enable" />
            </IconButton>
          </Tooltip>
        </Box>
        <Tooltip title="Excluir Colaborador">
          <IconButton size="small" onClick={() => onDelete(row)}>
            <img src={IconDelete} alt="delete" />
          </IconButton>
        </Tooltip>
      </Stack>
    ),
  },
]
